export interface AuthNavigationState {
    message?: string
    postLoginRestore?: boolean
}

export interface AuthRedirectTarget {
    to: string
    state?: AuthNavigationState
}

export const isPostLoginRestoreNavigationState = (
    state: unknown
): state is AuthNavigationState =>
    Boolean(
        state &&
            typeof state === 'object' &&
            (state as AuthNavigationState).postLoginRestore === true
    )
